import React from "react";
import "../styles/Footer.css";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const content = {
    about: {
      english: "Dedicated to the service of the nation and the welfare of the people. Working towards a strong, prosperous, and self-reliant India.",
      tamil: "தேச சேவைக்கும் மக்கள் நலனுக்கும் அர்ப்பணிக்கப்பட்டது. வலுவான, வளமான மற்றும் சுயாதீன இந்தியாவை நோக்கி பணியாற்றுகிறோம்."
    },
    quickLinks: {
      english: "Quick Links",
      tamil: "விரைவு இணைப்புகள்"
    },
    home: {
      english: "Home ",
      tamil: "முகப்பு"
    },
    missionVision: {
      english: "Mission & Vision",
      tamil: "குறிக்கோள் & பார்வை"
    },
    aboutUs: {
      english: "About Us",
      tamil: "எங்களை பற்றி"
    },
    contactUs: {
      english: "Contact Us",
      tamil: "தொடர்பு கொள்ளுங்கள்"
    },
    contactTitle: {
      english: "Contact Us",
      tamil: "தொடர்பு கொள்ளுங்கள்"
    },
    address: {
      english: "Pin - 637502",
      tamil: "அஞ்சல் குறியீடு - 637502"
    }
  };

  return (
    <footer className="footer">
      {/* LEFT - ABOUT */}
      <div className="footer-col footer-about">
        <div className="footer-brand">
          <img src="/assets/Container.png" alt="BJP Logo" />
          <div className="footer-brand1">
            <h2>AIADMK</h2>
            <p>All India Anna Dravida Munnetra Kazhagam. Dedicated to the welfare and development of Tamil Nadu.</p>
          </div>
        </div>

        {/* <p className="footer-text">
          {content.about[language]}
        </p> */}

        <div className="footer-social">
          <img src="/assets/Container (11).png" alt="Facebook" />
          <img src="/assets/Container (12).png" alt="Instagram" />
          <img src="/assets/Container (13).png" alt="Twitter" />
          <img src="/assets/Container (14).png" alt="YouTube" />
        </div>
      </div>

      {/* MIDDLE - QUICK LINKS */}
      <div className="footer-col">
        <h3 className="footer-title">{content.quickLinks[language]}</h3>
        <ul className="footer-links">
          <li onClick={() => navigate("/")}>
            {content.home[language]} &#8599;
          </li>
          <li onClick={() => navigate("/Mission-vission")}>
            {content.missionVision[language]} &#8599;
          </li>
          <li onClick={() => navigate("/About")}>
            {content.aboutUs[language]} &#8599;
          </li>
          <li onClick={() => navigate("/Contact")}>
            {content.contactUs[language]} &#8599;
          </li>
        </ul>
      </div>

      {/* RIGHT - CONTACT */}
      <div className="footer-col">
        <h3 className="footer-title">{content.contactTitle[language]}</h3>

        <div className="footer-contact">
          <img src="/assets/Frame (3).png" alt="Location" />
          <p>{content.address[language]}</p>
        </div>

        <div className="footer-contact">
          <img src="/assets/Frame (4).png" alt="Phone" />
          <p>+91 44 2813 2266</p>
        </div>

        <div className="footer-contact">
          <img src="/assets/Frame (5).png" alt="Email" />
          <p>info@aiadmk.org</p>
        </div>
      </div>

      <div className="footer-col">
        <h1 className="lastfoot1">Join Our List</h1>
        <p className="lastfoot2">Stay updated with party news and events.</p>
        <button className="lastfootbtn">Subscribe</button>
      </div>
    </footer>
  );
};

export default Footer;